import { useMemo } from "react";

import TableSimpleCell from "ds/components/TableSimple/Cell";
import SpacePath from "components/SpacePath";
import { Module } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import useCellFilterAction from "../useCellFilterAction";
import { ModulesSuggestions } from "../../FiltersLayout/constants";

const ModulesTableSpaceCell = ({ item: module, ...cellProps }: TableSimpleCellProps<Module>) => {
  const spaceFilterAction = useCellFilterAction({
    filterName: ModulesSuggestions.Space,
    filterValue: module.spaceDetails.id,
    spaceCell: true,
  });

  const actions = useMemo(() => [spaceFilterAction], [spaceFilterAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <SpacePath spaceId={module.spaceDetails.id} fallbackName={module.spaceDetails.name} />
    </TableSimpleCell>
  );
};

export default ModulesTableSpaceCell;
